import { SidebarModel } from "@syncfusion/ej2-react-navigations";

export type ContainerProps = {
  onExit: () => void; // Component calls this to signal it wants to close
  [key: string]: any; // Allow any additional props
};

export interface FlyoutContainerRegistryEntry {
  component: React.ComponentType<any>; // Accept any component type
  sidebarSettings?: Partial<SidebarModel>;
  defaultProps?: Record<string, any>; // Default props to be passed to the component
}

export interface FlyoutRegistrationConfig {
  key: string;
  component: React.ComponentType<any>; // Accept any component type
  sidebarSettings?: Partial<SidebarModel>;
  defaultProps?: Record<string, any>; // Default props to be passed to the component
}

export type FlyoutContainerRegistryMap = {
  [key: string]: FlyoutContainerRegistryEntry;
};

export class FlyoutContainerRegistry {
  private static instance: FlyoutContainerRegistry;
  private flyouts: FlyoutContainerRegistryMap = {};

  private constructor() {}

  static getInstance() {
    if (!FlyoutContainerRegistry.instance) {
      FlyoutContainerRegistry.instance = new FlyoutContainerRegistry();
    }
    return FlyoutContainerRegistry.instance;
  }

  register(
    key: string,
    component: React.ComponentType<any>,
    sidebarSettings?: Partial<SidebarModel>,
    defaultProps?: Record<string, any>,
    replaceExistingRegistration: boolean = true
  ) {
    if (this.flyouts[key] && !replaceExistingRegistration) {
      throw new Error(`Flyout with key ${key} already registered`);
    }

    this.flyouts[key] = {
      component,
      sidebarSettings,
      defaultProps,
    };
  }

  unregister(key: string) {
    delete this.flyouts[key];
  }

  /**
   * Register flyouts - accepts array of flyout configurations
   */
  registerFlyouts(
    configs: FlyoutRegistrationConfig[],
    replaceExistingRegistration: boolean = true
  ) {
    configs.forEach((config) => {
      this.register(
        config.key,
        config.component,
        config.sidebarSettings,
        config.defaultProps,
        replaceExistingRegistration
      );
    });
  }

  /**
   * Unregister multiple flyouts at once
   */
  unregisterMultiple(keys: string[]) {
    keys.forEach((key) => {
      this.unregister(key);
    });
  }

  /**
   * Clear all registered flyouts
   */
  clear() {
    this.flyouts = {};
  }

  getFlyouts() {
    return this.flyouts;
  }
}

export const flyoutContainerRegistry = FlyoutContainerRegistry.getInstance();
